import React, { useCallback, useEffect, useMemo } from 'react'
import { useFormik } from 'formik'
import { useDispatch, useSelector } from 'react-redux'

import Form from '../../../../../../components/Form'
import UpdateBookedMediaCustomDatesFormContent from './UpdateBookedMediaCustomDatesFormContent'

import { transformValuesToBE } from './formatters'

import {
  updateBookedMediaErrorSelector,
  updateBookedMediaIsLoadingSelector,
  updateBookedMediaWasUpdatedSelector
} from '../../../../../../modules/selectors/mediaOrdersBookings'
import {
  clearUpdateBookedMedia,
  getMediaOrderRequestedFiles,
  updateBookedMedia
} from '../../../../../../modules/actions/mediaOrdersBookings'
import { formItemIdSelector } from '../../../../../../modules/selectors/forms'

import { UPDATE_CUSTOM_FILE_UPLOAD_DATES } from '../../../../../../constants/forms'
import { getInitialValues } from './fields'

const UpdateBookedMediaCustomDatesForm = ({ mediaOrderId, bookedMediaData }) => {
  const dispatch = useDispatch()
  const wasUpdated = useSelector(updateBookedMediaWasUpdatedSelector)

  const { [UPDATE_CUSTOM_FILE_UPLOAD_DATES]: selectedBookedMediaId } = useSelector(formItemIdSelector)

  const onSubmit = useCallback(
    values => {
      const transformedData = transformValuesToBE(values)

      dispatch(updateBookedMedia(selectedBookedMediaId, transformedData))
    },
    [dispatch, selectedBookedMediaId]
  )

  const clearHandler = useCallback(() => {
    dispatch(clearUpdateBookedMedia())
  }, [dispatch])

  const initialValues = useMemo(() => {
    return getInitialValues(bookedMediaData)
  }, [bookedMediaData])

  const formik = useFormik({
    initialValues,
    onSubmit
  })

  useEffect(() => {
    if (wasUpdated) {
      // refetch the requested files after the custom dates update, to populate the new dates and remove the regular or old ones
      dispatch(getMediaOrderRequestedFiles({ id: mediaOrderId }))
    }
  }, [dispatch, mediaOrderId, wasUpdated])

  return (
    <Form
      formik={formik}
      formName={UPDATE_CUSTOM_FILE_UPLOAD_DATES}
      successSubmit={wasUpdated}
      errorSelector={updateBookedMediaErrorSelector}
      isLoadingSelector={updateBookedMediaIsLoadingSelector}
      clearHandler={clearHandler}
    >
      <UpdateBookedMediaCustomDatesFormContent formik={formik} bookedMediaDateStart={bookedMediaData.date_start} />
    </Form>
  )
}

export default UpdateBookedMediaCustomDatesForm
